import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Blamable               from '@/models/traits/Blamable';
import FondationsServiceModel from '@/models/FondationsServiceModel';
import Translatable           from '@widesk-core/models/traits/Translatable';

@model.cacheDuration()
@model.urnResource('show')
@doc.path('/shows/{?id}')
export default class ShowModel extends Blamable(TimestampAble(Translatable(FondationsServiceModel, {
	'name': true,
}))) {
	private declare _tsFilters: {
		'id': id;
		'translations.name': string;
	};

	@doc.string declare reference: string;
	@doc.string declare color: string;
}
